angular.module('detailerBlacklist', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/detailer-blacklist/detailer-blacklist.module.js